<template>
  <v-layout class="cat-box md11 xs12 flex" column mb-3 id="all-cats">
    <CategoryImage :numberOfJobs="catItem.name" :catCode="catItem.id" :catImage="catItem.id"/>
    <CategoryHeader :catName="catItem.name" :catCode="catItem.id" />
    <CategoryLink :catName="catItem.name" :catCode="catItem.id" :subCategories="catItem.sub_categories" />
  </v-layout>
</template>

<script>
import CategoryHeader from '@/components/CategoriesPage/CategoryItem/CategoryHeader'
import CategoryImage from '@/components/CategoriesPage/CategoryItem/CategoryImage'
import CategoryLink from '@/components/CategoriesPage/CategoryItem/CategoryLink'

export default {
  components: {CategoryHeader,CategoryImage,CategoryLink},

  props: {
    catItem: {
      type: Object,
      required: false,
      default: () => {}
    }
  },

}
</script>

<style lang="scss" scoped>
p{
  margin-bottom:0
}
.ca-hdr p{
  background-color: #f6f7f9;
  padding: 3px 10px 2px 0;
  border-radius: 0 0 5px 5px;
  position:relative

}
.ca-hdr p:after{
  content:"\276f";
  position:absolute ;
  left:4px;
  color:$primary;
  font-size:12px;
  line-height:30px
}

.cat-img {
  position: relative;
}

.cat-img .v-responsive {
  border-radius: 5px 5px 0 0;
  max-height: 115px;
  opacity:0.5
}

.cat-img .cat-jobs {
  font-size: 12px;
  position: absolute;
  z-index: 1;
  top: 5px;
  left: 5px;
  display: inline-flex;
  color: $primary;
  background: rgba(255, 255, 255, 0.8);
  padding: 2px 16px;
  border-radius: 13px;
}
</style>